import { toast } from 'react-toastify';

// Function to show a success toast
export const successToast = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000, 
  });
};

// Function to show an error toast
export const errorToast = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
  });
};

// Function to show a warning toast
export const warnToast = (message) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: 2000,
  });
};

// Variant-aware toast dispatcher; `variant` wins over the legacy `success` flag when provided.
export const toaster = ({ message, success, variant }) => {
  const resolved = variant || (success ? 'success' : 'error');
  if (resolved === 'warning') return warnToast(message);
  if (resolved === 'success') return successToast(message);
  return errorToast(message);
};
